import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import { getHttpsCallableErrorMessage } from "services/partnerTierService";

const getFunctions = () => firebase.app().functions("us-central1");

export { getHttpsCallableErrorMessage };

/**
 * Balances for a Founding Partner org plus linked Fusion Partners/Affiliates.
 */
export async function getPartnerLedgerBalances({ foundingPartnerOrgId }) {
  const callable = getFunctions().httpsCallable("getPartnerLedgerBalances");
  const result = await callable({ foundingPartnerOrgId });
  return result.data;
}

/**
 * Ledger entries for a Founding Partner hierarchy (newest first).
 */
export async function listPartnerLedgerEntries({ foundingPartnerOrgId }) {
  const callable = getFunctions().httpsCallable("listPartnerLedgerEntries");
  const result = await callable({ foundingPartnerOrgId });
  return result.data;
}

/**
 * Create an immutable manual ledger entry and refresh attributed-org balances.
 */
export async function createPartnerLedgerEntry({
  foundingPartnerOrgId,
  attributedOrgId,
  eventType,
  amount,
  currency,
  description,
  settlementRail = null,
}) {
  const callable = getFunctions().httpsCallable("createPartnerLedgerEntry");
  const result = await callable({
    foundingPartnerOrgId,
    attributedOrgId,
    eventType,
    amount,
    currency,
    description,
    settlementRail,
  });
  return result.data;
}
